import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    if(sessionStorage.getItem('authKey')){

        //  request = request.clone({
        //     setHeaders:{
        //         "Content-Type": "application/json",
        //         Authorization : `JWT  ${sessionStorage.getItem('authKey')}`
        //     }
        // })

    }

    return next.handle(request);
  }
}
